@if (isLoading()) {
  <mwe-loading-spinner-extended />
} @else {
  <mwe-wizard [wizardModel]="wizardModel()" #wizard>
    <router-outlet (activate)="wizard.onActivate($event, wizardModel())" />
  </mwe-wizard>
}
